import { SharedLocale, type SharedLocalizedString } from "../SharedLocale.js";

export const solutionsPathMap = {
	[SharedLocale.cs]: "nase-reseni",
	[SharedLocale.en]: "our-solutions",
	[SharedLocale.pl]: "nasze-rozwiazania",
	[SharedLocale.sk]: "nase-riesenia",
} satisfies SharedLocalizedString;
